import { createContext, useContext } from "react";
import type { User } from "firebase/auth";

export type AuthState =
  | { status: "loading" }
  | { status: "unauthenticated" }
  | { status: "authenticated"; user: User };

export const AuthStateContext = createContext<AuthState>({ status: "loading" });

export function useAuthState(): AuthState {
  return useContext(AuthStateContext);
}
